// extracted by mini-css-extract-plugin
export default {"wrapper":"MarketingTextSection_wrapper__oKDqe","header":"MarketingTextSection_header__j5p4J","field":"MarketingTextSection_field__Tgbee"};